import { render, staticRenderFns } from "./centList.vue?vue&type=template&id=193e4670&scoped=true&"
import script from "./centList.vue?vue&type=script&lang=js&"
export * from "./centList.vue?vue&type=script&lang=js&"
import style0 from "./centList.vue?vue&type=style&index=0&id=193e4670&scoped=true&lang=css&"
import style1 from "./centList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e4670",
  null
  
)

export default component.exports